import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../../AuthContext';
import { useEffect, useState } from 'react';
import './RightElements.css';
import conti from '../../images/conti.gif';


const GetProCard = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [isPremium, setIsPremium] = useState(
    user?.is_premium === true
  );

  // Verifica statutul Premium direct din backend
  useEffect(() => {
    let cancelled = false;

    const fetchPremiumStatus = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/user`,
          {
            method: 'GET',
            credentials: 'include',
          }
        );

        if (!response.ok) return;

        const data = await response.json();

        if (!cancelled) {
          setIsPremium(data?.is_premium === true);
        }
      } catch (error) {
        console.error(
          'Eroare verificare Premium in GetProCard:',
          error
        );
      }
    };

    fetchPremiumStatus();

    return () => {
      cancelled = true;
    };
  }, []);

  // Sincronizare cu AuthContext
  useEffect(() => {
    if (typeof user?.is_premium === 'boolean') {
      setIsPremium(user.is_premium);
    }
  }, [user?.is_premium]);



const handleButtonClick = () => {
  if (isPremium) {
    navigate('/premium');
    return;
  }

  navigate('/premium/plans');
};


  return (
    <div
      className={`rightmenu-card get-pro-card ${
        isPremium ? 'get-pro-card-premium' : ''
      }`}
    >
      <div className="get-pro">

        <img
          src={conti}
          alt="ContaLearn mascot"
          className="get-pro-mascot"
        />

        {isPremium ? (
          <>
            <div className="get-pro-premium-title">
              <FontAwesomeIcon
                icon={faCrown}
                className="get-pro-premium-crown"
                aria-hidden="true"
              />

              <span>Premium activ</span>
            </div>

            <div className="get-pro-desc">
              Ai acces complet la ContaLearn si la toate beneficiile Premium!
            </div>
          </>
        ) : (
          <>
            <div className="get-pro-title">
              Invata fara limite
            </div>

            <div className="get-pro-desc">
              Descopera toate beneficiile ContaLearn Premium!
            </div>
          </>
        )}

        <button
          type="button"
          className="go-premium"
          onClick={handleButtonClick}
        >
          <FontAwesomeIcon
            icon={faCrown}
            className="go-premium-crown"
            aria-hidden="true"
          />

          <span>
            {isPremium ? 'Cont Premium' : 'Treci la Premium'}
          </span>
        </button>

      </div>
    </div>
  );
};

export default GetProCard;